<template>
  <v-card elevation="0">
    <v-col>
      <div><b>{{$t('title')}}</b> : {{competitionTitle}} </div>
    </v-col>
    <v-col>
      <div><b>{{$t('dates')}}</b> : {{startdate}} -  {{enddate}} </div>
    </v-col>
    <v-col>
      <div><b>{{$t('companies')}}</b></div>
      <v-list disabled>
        <v-list-item
            v-for="company in companies"
            :key="company.id"
        >
          <v-list-item-content>
            <v-list-item-title>{{ company.value }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>
    <v-col>
      <div><b>{{$t('badges')}}</b></div>
      <v-list disabled>
        <v-list-item compact
                     two-line
                     v-for="badge in badges"
                     :key="badge.id"
        >
          <v-list-item-content>
            <v-list-item-title>{{ $t('title')}}: {{ badge.value }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('points')}}: {{ badge.points }} | {{ $t('limit')}}: {{ badge.limit !== '' && badge.limit !== 0 ? badge.limit : $t('no_limit') }}</v-list-item-subtitle>

          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>
  </v-card>
</template>
<script>
export default {
  name: "CompetitionInfo",
  props: {
    companies: {
      required: true
    },
    badges: {
      required: true,
    },
    competitionTitle: {
      required: true
    },
    startdate: {
      required: true
    },
    enddate: {
      required: true
    }
  }
};
</script>